export const SCOREBOARD_TIMING = {
  vehicleStagger: 0.08,
  vehicleRise: 0.45,
  digitsAt: 0.5,
  tensDur: 1.0,
  onesDur: 1.22,
  totalDur: 1.65,
};
